import type { StreamStep } from "~/helpers/aiChat/streamSteps";

import { Box, Button, Icon } from "@mui/material";

import FernieVoiceText from "~/components/fernie/FernieVoiceText";
import { BodyTextSmall } from "~/components/Typographies";

interface FernieStreamProgressProps {
	hasContent: boolean;
	onStop: () => void;
	steps: StreamStep[];
	waitingLabel: string;
}

const StepIcon = ({ status }: { status: StreamStep["status"] }) => {
	if (status === "success") return <Icon sx={{ color: "success.main", fontSize: 15 }}>check_circle</Icon>;
	if (status === "error") return <Icon sx={{ color: "error.main", fontSize: 15 }}>error</Icon>;
	return (
		<Box
			sx={{ backgroundColor: "primary.main", borderRadius: "50%", flexShrink: 0, height: 8, mx: "3.5px", width: 8 }}
		/>
	);
};

const FernieStreamProgress = ({ hasContent, onStop, steps, waitingLabel }: FernieStreamProgressProps) => (
	<Box sx={{ display: "flex", flexDirection: "column", gap: 0.75, mt: hasContent || steps.length > 0 ? 1 : 0 }}>
		{steps.length > 0
			? steps.map((step, index) => (
					<Box key={`${step.toolName}-${index}`} sx={{ alignItems: "center", display: "flex", gap: 1 }}>
						<StepIcon status={step.status} />
						<BodyTextSmall
							sx={{ color: step.status === "active" ? "text.secondary" : "text.disabled", fontSize: "0.78rem" }}
						>
							{step.label}
						</BodyTextSmall>
					</Box>
				))
			: !hasContent && (
					<FernieVoiceText component="div" sx={{ color: "text.secondary", fontSize: "0.78rem" }}>
						{waitingLabel}
					</FernieVoiceText>
				)}
		<Box>
			<Button
				onClick={onStop}
				size="small"
				startIcon={<Icon sx={{ fontSize: 16 }}>stop_circle</Icon>}
				sx={{ color: "text.secondary", minWidth: 0, px: 1, textTransform: "none" }}
			>
				Stop
			</Button>
		</Box>
	</Box>
);

export default FernieStreamProgress;
